import { connect } from 'react-redux';
import { compose } from 'redux';
import { createSprintUpgrade as createUpgradePurchase } from '../actions';
import { updatePlan } from 'subscriptions/sprint/actions';
import { getSprintUpgradePurchase } from 'reducers';
import subscriptionDecorator from 'subscriptions/decorator';
import UpgradePurchase from './UpgradePurchase';

const mapStateToProps = (state, { subId }) => ({
  purchase: getSprintUpgradePurchase(state, subId)
});

const mapDispatchToProps = {
  createUpgradePurchase,
  updatePlan,
}

export default compose(
  subscriptionDecorator,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(UpgradePurchase);
